/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Manage_Credits_TitleInputs */

const en_admin_users_manage_credits_title = /** @type {(inputs: Admin_Users_Manage_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Credits`)
};

const zh_admin_users_manage_credits_title = /** @type {(inputs: Admin_Users_Manage_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理积分`)
};

/**
* | output |
* | --- |
* | "Manage Credits" |
*
* @param {Admin_Users_Manage_Credits_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_manage_credits_title = /** @type {((inputs?: Admin_Users_Manage_Credits_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Manage_Credits_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_manage_credits_title(inputs)
	return zh_admin_users_manage_credits_title(inputs)
});
export { admin_users_manage_credits_title as "admin.users.manage_credits_title" }